/* Tema Ojo de Ratón (2026-11-03): catálogo, galería y bolsa conectados al carrito real de Shopify. */
(() => {
  const $ = (s, el = document) => el.querySelector(s), $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents, cur) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: cur || 'COP', maximumFractionDigits: 0 }).format(cents / 100);
  let tt;
  const toast = m => { const el = $('#toast'); el.textContent = m; el.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => el.classList.remove('show'), 3200) };

  /* Menú de la tienda */
  const mega = $('#mega'), shop = $('#shopMenu');
  shop?.addEventListener('click', () => { mega.hidden = !mega.hidden; shop.setAttribute('aria-expanded', !mega.hidden) });
  document.addEventListener('click', e => { if (mega && !mega.hidden && !e.target.closest('#mega,#shopMenu')) { mega.hidden = true; shop.setAttribute('aria-expanded', 'false') } });

  /* Catálogo: filtros, búsqueda, orden y «ver más» sobre las tarjetas que ya pintó Shopify */
  const grid = $('#products'), status = $('#catalogStatus'), more = $('#loadMore'), STEP = 12;
  if (grid && status) {
    const cards = $$('.product', grid); cards.forEach((c, i) => c.dataset.pos = i);
    let cat = new URLSearchParams(location.search).get('cat') || 'Todos', q = '', sort = 'selection', limit = STEP;
    const paint = () => {
      const list = cards.filter(c => (cat === 'Todos' || c.dataset.cat === cat) && (!q || c.dataset.search.includes(q)));
      const by = { selection: (a, b) => a.dataset.pos - b.dataset.pos, 'price-up': (a, b) => a.dataset.price - b.dataset.price, 'price-down': (a, b) => b.dataset.price - a.dataset.price, brand: (a, b) => a.dataset.brand.localeCompare(b.dataset.brand, 'es') }[sort];
      list.sort(by);
      cards.forEach(c => c.hidden = true);
      list.forEach((c, i) => { grid.append(c); c.hidden = i >= limit });
      status.textContent = list.length ? `${list.length} ${list.length === 1 ? 'PRODUCTO' : 'PRODUCTOS'}` : 'NO ENCONTRAMOS PRODUCTOS. PRUEBA CON OTRA PALABRA.';
      if (more) more.hidden = list.length <= limit;
      $$('.filters [data-filter]').forEach(b => b.classList.toggle('active', b.dataset.filter === cat));
    };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-filter]');
      if (b) { cat = b.dataset.filter; limit = STEP; paint() }
    });
    $('#catalogSearch')?.addEventListener('input', e => { q = e.target.value.trim().toLowerCase(); limit = STEP; paint() });
    $('#catalogSort')?.addEventListener('change', e => { sort = e.target.value; paint() });
    more?.addEventListener('click', () => { limit += STEP; paint() });
    paint();
  }
  document.addEventListener('click', e => {
    const card = e.target.closest('.product');
    if (card && !e.target.closest('a,button,input')) location.href = card.dataset.url;
  });

  /* Bolsa */
  const drawer = $('#drawer'), back = $('#backdrop'), box = $('#drawerContent');
  const open = () => { drawer.hidden = false; back.hidden = false; document.body.style.overflow = 'hidden'; $('#closeDrawer').focus() };
  const close = () => { drawer.hidden = true; back.hidden = true; document.body.style.overflow = '' };
  const json = (url, opt) => fetch(root + url, opt).then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.description || d.message || 'No se pudo completar.'); return d });
  const post = (url, body) => json(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  function paintCart(c) {
    const n = $('#count'); if (n) n.textContent = c.item_count;
    if (!box) return;
    box.innerHTML = c.items.length ? `<div class="drawer-lines">${c.items.map((it, i) => `<div class="cart-row">
        ${it.image ? `<img src="${esc(it.image)}" alt="" loading="lazy">` : '<span></span>'}
        <div><a href="${esc(it.url)}">${esc(it.product_title)}</a><p>${esc(it.vendor)}</p>
          <div class="line-qty"><button type="button" data-line="${i + 1}" data-to="${it.quantity - 1}" aria-label="Quitar una unidad">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-to="${it.quantity + 1}" aria-label="Agregar una unidad">+</button></div></div>
        <strong>${money(it.final_line_price, c.currency)}</strong></div>`).join('')}</div>
      <div class="drawer-total"><span>Subtotal</span><strong>${money(c.total_price, c.currency)}</strong></div>
      <p class="drawer-note">El envío se calcula al finalizar la compra.</p>
      <a class="solid-button" href="${root}checkout">FINALIZAR COMPRA <span>↗</span></a>`
      : `<p>Tu bolsa está vacía.</p><a class="solid-button" href="${root}#coleccion">EXPLORA LA SELECCIÓN <span>↗</span></a>`;
  }
  const refresh = () => json('cart.js').then(paintCart);
  const add = (id, quantity) => post('cart/add.js', { items: [{ id: +id, quantity }] }).then(refresh).then(open).catch(e => toast(e.message));
  $('#cartOpen')?.addEventListener('click', () => { open(); refresh().catch(e => toast(e.message)) });
  $('#closeDrawer')?.addEventListener('click', close);
  back?.addEventListener('click', close);
  addEventListener('keydown', e => { if (e.key === 'Escape' && drawer && !drawer.hidden) close() });
  box?.addEventListener('click', e => {
    const b = e.target.closest('[data-line]'); if (!b) return;
    post('cart/change.js', { line: +b.dataset.line, quantity: +b.dataset.to }).then(paintCart).catch(er => toast(er.message));
  });
  document.addEventListener('click', e => { const b = e.target.closest('[data-add]'); if (b) add(b.dataset.add, 1) });

  /* Página de producto */
  const main = $('#pdp-main');
  if (main) {
    const thumbs = $$('[data-photo]'); let idx = 0;
    const show = i => {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      main.src = thumbs[idx].dataset.src; main.alt = thumbs[idx].dataset.alt;
      thumbs.forEach((t, k) => t.setAttribute('aria-pressed', k === idx));
      const c = $('.pdp-photo-count'); if (c) c.textContent = `${idx + 1} / ${thumbs.length}`;
      $('.pdp-zoom')?.classList.remove('zoomed');
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $$('[data-photo-step]').forEach(b => b.addEventListener('click', () => show(idx + +b.dataset.photoStep)));
    $('.pdp-zoom')?.addEventListener('click', e => { const z = e.currentTarget; z.classList.toggle('zoomed'); z.setAttribute('aria-label', z.classList.contains('zoomed') ? 'Reducir imagen' : 'Ampliar imagen') });
    const form = $('#comprar'), addBtn = $('.pdp-add');
    const qtyField = form?.querySelector('[name=quantity]');
    const maxQty = () => Math.max(1, Math.min(10, +addBtn?.dataset.max || 10));
    $$('[data-detail-qty]').forEach(b => b.addEventListener('click', () => {
      const v = Math.max(1, Math.min(maxQty(), +qtyField.value + +b.dataset.detailQty));
      qtyField.value = v; $('#pdp-qty').textContent = v;
    }));
    form?.addEventListener('submit', e => {
      e.preventDefault(); if (addBtn.disabled) return;
      add(form.querySelector('[name=id]').value, +qtyField.value);
    });
    document.addEventListener('click', e => {
      const a = e.target.closest('.pas-return-purchase'); if (!a) return;
      e.preventDefault(); $('.pdp-purchase').scrollIntoView({ behavior: 'smooth', block: 'center' }); addBtn.focus({ preventScroll: true });
    });
  }
})();
;(()=>{const c=[...document.querySelectorAll('.product')].map(x=>x.dataset.cat);document.querySelectorAll('.filters [data-filter]').forEach(b=>{if(b.dataset.filter!=='Todos'&&!c.includes(b.dataset.filter))b.hidden=true})})();